<template>
  <div class="page-nav-container">
    <el-menu class="page-nav" :default-active="active" :default-openeds="default_opened" ref="menu">
      <el-menu-item :index="$location.admin_channel().name" v-if="$location.admin_channel.auth()">
        <router-link :to="$location.admin_channel(false)">
          <icon name="rocket"></icon>
          渠道管理
        </router-link>
      </el-menu-item>
      <el-menu-item :index="$location.admin_school().name" v-if="$user.$$is_channel">
        <router-link :to="$location.admin_school(false)">
          <icon name="university"></icon>
          学校管理
        </router-link>
      </el-menu-item>
      <template v-if="$user.$$is_teacher">
        <el-menu-item :index="$location.admin_group().name" v-if="$location.admin_group.auth()">
          <router-link :to="$location.admin_group(false)">
            <icon name="users"></icon>
            班级管理
          </router-link>
        </el-menu-item>
        <el-menu-item :index="$location.admin_teacher().name" v-if="$location.admin_teacher.auth()">
          <router-link :to="$location.admin_teacher(false)">
            <icon name="user"></icon>
            人员管理
          </router-link>
        </el-menu-item>
        <el-menu-item :index="$location.admin_student().name" v-if="$location.admin_student.auth()">
          <router-link :to="$location.admin_student(false)">
            <icon name="graduation-cap"></icon>
            学生管理
          </router-link>
        </el-menu-item>
        <el-menu-item :index="$location.admin_department().name" v-if="$location.admin_department.auth()">
          <router-link :to="$location.admin_department(false)">
            <icon name="cubes"></icon>
            部门配置
          </router-link>
        </el-menu-item>
        <el-submenu index="文件收集任务"
                    v-if="$location.admin_collection_edit.auth() || $location.admin_collection_list.auth()">
          <template slot="title">
            <a>
              <icon name="list-ul"></icon>
              文件收集任务
            </a>
          </template>
          <el-menu-item :index="$location.admin_collection_edit().name"
                        v-if="$location.admin_collection_edit.auth()">
            <router-link :to="$location.admin_collection_edit(false)">
              发布上传任务
            </router-link>
          </el-menu-item>
          <el-menu-item :index="$location.admin_collection_list().name"
                        v-if="$location.admin_collection_list.auth()">
            <router-link :to="$location.admin_collection_list(false)">
              文件收集情况
            </router-link>
          </el-menu-item>
        </el-submenu>
        <el-menu-item :index="$location.admin_file_center().name" v-if="$location.admin_file_center.auth()">
          <router-link :to="$location.admin_file_center(false)">
            <icon name="share-alt"></icon>
            部门文件共享
          </router-link>
        </el-menu-item>
        <el-submenu index="教师成果"
                    v-if="$location.admin_achievement_check_list.auth() ||
                         $location.admin_achievement_list.auth() ||
                          $location.admin_achievement_template_list.auth()">
          <template slot="title">
            <a>
              <icon name="folder-o"></icon>
              教师成果
            </a>
          </template>
          <el-menu-item :index="$location.admin_achievement_check_list().name"
                        v-if="$location.admin_achievement_check_list.auth()">
            <router-link :to="$location.admin_achievement_check_list(false)">
              <icon>
                <icon name="file-o"></icon>
                <icon name="search" scale="0.65"></icon>
              </icon>
              成果审核
            </router-link>
          </el-menu-item>
          <el-menu-item :index="$location.admin_achievement_list().name"
                        v-if="$location.admin_achievement_list.auth()">
            <router-link :to="$location.admin_achievement_list(false)">
              <icon name="files-o"></icon>
              成果浏览
            </router-link>
          </el-menu-item>
          <el-menu-item :index="$location.admin_achievement_template_list().name"
                        v-if="$location.admin_achievement_template_list.auth()">
            <router-link :to="$location.admin_achievement_template_list(false)">
              <icon name="file-archive-o"></icon>
              批量导入
            </router-link>
          </el-menu-item>
        </el-submenu>
      </template>
    </el-menu>
    <div class="page-content">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      default_opened: ['教师成果', '文件收集任务'],
      active: null,
      coming_soon: [],
    }
  },
  methods: {
    init () {
      if (this.$refs.menu.items[this.$route.name]) {
        this.active = this.$route.name
      } else if (this.$refs.menu.items[this.$route.name + JSON.stringify(this.$query)]) {
        this.active = this.$route.name + JSON.stringify(this.$query)
      }
    },
  },
  mounted () {
    this.init()
  },
  watch: {
    $route () { if (!this.$dontReload) this.init() },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Admin.vue